module.exports = __webpack_public_path__ + "static/media/locPoint.f857574a.svg";